<template lang="html">
  <div class="about-us">
    <div class="">
      <img v-lazy="aboutUsData.coverImg" alt="" class="pc">
    </div>
    <div class="detail">
      <div class="">
        <div class="top">
          <h1>{{aboutUsData.detail.title}}</h1>
          <span class="pc">COMPANY PROFILE</span>
        </div>
        <div class="detail-box">
          <img v-lazy="aboutUsData.detail.contentImg" alt="" class="pc">
          <p>{{aboutUsData.detail.content}}</p>
        </div>
      </div>
    </div>
    <div class="title">
      <div class="top">
        <h1>企业文化</h1>
        <span class="pc">CORPORATE CULTURE</span>
      </div>
    </div>
    <div class="swp">
      <div class="">
        <swiper :options="swiperOption" ref="mySwiper">
          <!-- slides -->
          <swiper-slide v-for="(item, index) in aboutUsData.detail.imgList" :key="index">
            <img :src="item.img" alt="" class="pc">
          </swiper-slide>
          <!-- <swiper-slide>
            <img src="~common/pc/images/league_building_02.png" alt="" class="pc">
          </swiper-slide>
          <swiper-slide>
            <img src="~common/pc/images/league_building_03.png" alt="" class="pc">
          </swiper-slide> -->
          <!-- <swiper-slide>
            <img src="~common/pc/images/league_building_01.png" alt="" class="pc">
          </swiper-slide> -->
        </swiper>
        <div class="swiper-button-prev pc" slot="button-prev"></div>
        <div class="swiper-button-next pc" slot="button-next"></div>
      </div>
    </div>
    <div class="history">
      <div class="">
        <div class="top">
          <h1>发展历史</h1>
          <span class="pc">DEVELOPMENT HISTORY</span>
        </div>
        <div class="">
          <ul class="history-detail">
            <li v-for="(item, index) in aboutUsData.history" :key="index">
              <div class="lf">
                {{item.date}}
              </div>
              <div class="rt">
                <img v-lazy="item.bakImg" alt="">
                <ul>
                  <li v-for="(inItem, inIndex) in item.detail" :key="inIndex">{{inItem.item}}</li>
                </ul>
              </div>
            </li>
            <!-- <li>
              <div class="lf">
                2019
              </div>
              <div class="rt">
                <img src="~common/pc/images/course_background.png" alt="">
                <ul>
                  <li>圣经APP问世</li>
                  <li>福音广告开始测试</li>
                  <li>产品技术部成立、更名“因他科技”</li>
                </ul>
              </div>
            </li>
            <li>
              <div class="lf">
                2018
              </div>
              <div class="rt">
                <img src="~common/pc/images/course_background.png" alt="">
                <ul>
                  <li>附近的教堂小程序首次上线</li>
                  <li>教会通问世</li>
                  <li>恩典365 Html5 版本发布了~</li>
                </ul>
              </div>
            </li>
            <li>
              <div class="lf">
                2017
              </div>
              <div class="rt">
                <img src="~common/pc/images/course_background.png" alt="">
                <ul>
                  <li>主内云团队建立</li>
                  <li>成立媒体部，第一批公众号开始运营</li>
                </ul>
              </div>
            </li>
            <li>
              <div class="lf">
                2013-2016
              </div>
              <div class="rt">
                <img src="~common/pc/images/course_background.png" alt="">
                <ul>
                  <li>主内云团队建立</li>
                  <li>成立媒体部，第一批公众号开始运营</li>
                </ul>
              </div>
            </li> -->
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import aboutUsData from 'common/pc/js/aboutUs'
import 'swiper/dist/css/swiper.css'
import 'common/pc/stylus/base.styl'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  data () {
    return {
      aboutUsData: null,
      swiperOption: {
        notNextTick: true, // 循环
        loop: true, // 设定初始化时slide的索引
        initialSlide: 0, // 自动播放
        // autoplay: true,
        // autoplay: {
        //     delay: 3000,
        //     stopOnLastSlide: false,
        //     disableOnInteraction: true,
        // },
        // 设置轮播
        // effect: 'flip',
        // 滑动速度
        speed: 800,
        // 滑动方向
        direction: 'horizontal',
        // 小手掌抓取滑动
        // grabCursor : true,
        // 滑动之后回调函数
        // on: {
        //   slideChangeTransitionEnd: function () {
        //     // console.log(this.activeIndex);//切换结束时，告诉我现在是第几个slide
        //   }
        // },
        slidesPerView: 3,
        spaceBetween: 66,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        // 分页器设置
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      }
    }
  },
  created () {
    this.aboutUsData = aboutUsData
  },
  components: {
    swiper,
    swiperSlide
  },
  computed: {
    swiper () {
      return this.$refs.mySwiper.swiper
    }
  },
  mounted () {
    // current swiper instance
    // 然后你就可以使用当前上下文内的swiper对象去做你想做的事了
    console.log('this is current swiper instance object', this.swiper)
    // this.swiper.slideTo(3, 1000, false)
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.title
  width: 1400px
  padding: 20px 0
  margin: auto
.home>div
  position: relative
img
  width: 100%
.top
  padding-left: 20px
  position: relative
  h1
    font-size: 24px
    color: #007CE5
    margin-bottom: 10px
  span
    font-size: 18px
    color: #EEEEEE
  &:after
    content: ''
    width: 10px
    height: 20px
    position: absolute
    left: 0
    top: 4px
    background-color: #007CE5
.detail
  width: 100%
  padding: 50px 0 34px
  background-color: #fff
  &>div
    width: 1400px
    margin: auto
  .detail-box
    display: flex
    margin-top: 20px
    img
      flex: 0 0 500px
      width: 500px
      height: 260px
    p
      width: calc(100% - 500px)
      font-size: 18px
      color: #333
      padding-left: 54px
      line-height: 2
.history
  width: 100%
  padding: 50px 0 10px
  background-color: #fff
  &>div
    width: 1400px
    margin: auto
  .history-detail
    display: flex
    flex-wrap: wrap
    padding: 20px 0
    &>li
      flex: 0 0 441px
      height: 200px
      display: flex
      margin-bottom: 40px
      &:nth-of-type(3n-1)
        margin: 0 35px
      .lf
        flex: 0 0 72px
        display: flex
        justify-content: center
        align-items: center
        font-size: 24px
        color: #fff
        background-color: #007CE5
        word-break: break-all
        padding: 0 20px
        writing-mode: vertical-lr
        writing-mode: tb-lr
        font-weight: bolder
      .rt
        flex: 1
        position: relative
        img
          width: 369px
          height: 200px
        ul
          width: 100%
          height: 100%
          position: absolute
          left: 0
          top: 0
          right: 0
          display: flex
          justify-content: center
          flex-direction: column
          font-size: 20px
          color: #333
          padding-left: 26px
          box-sizing: border-box
          li
            position: relative
            padding: 5px 0
            &:after
              content: ''
              width: 10px
              height: 10px
              position: absolute
              left: -15px
              top: 12px
              background-color: rgba(0, 124, 229, .5)
              border-radius: 10px
.swp
  background-color: #F5F5F5
  padding: 30px 0
  .top
    width: 1400px
    padding-bottom: 20px
  &>div
    width: 1200px
    position: relative
    margin: auto
.swiper-button-prev
  left: -80px
.swiper-button-next
  right: -80px
</style>



// WEBPACK FOOTER //
// src/components/pc/aboutUs/aboutUs.vue